import React from 'react'

export const  AuthContext = React.createContext({
    email: "",
    status: false,
    setStatus: ()=>{},
  });